import React, { useState } from 'react'
import { Form, Formik } from 'formik'
import Div from '@jumbo/shared/Div'
import JumboCardQuick from '@jumbo/components/JumboCardQuick'
import JumboAppTextField from '@jumbo/components/JumboAppTextField'
import LoadingButton from '@mui/lab/LoadingButton'
import SearchIcon from '@mui/icons-material/Search'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { Checkbox, FormControlLabel, FormGroup, useMediaQuery } from '@mui/material'
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded'
import { useJumboTheme } from '@jumbo/hooks'

const NotifyGridFilter = ({ mutation, display, filterIconColor }) => {
    const [includeDeletedRecords, setincludeDeletedRecordsSelection] = useState(false)
    const { theme } = useJumboTheme()
    const sm = useMediaQuery(theme.breakpoints.down('sm'))

    let initialValues = {
        heading: '',
        includeDeletedRecords: false,
    }

    const onFormSubmit = (heading) => {
        mutation.mutate({
            heading: heading,
            includeDeletedRecords: includeDeletedRecords,
            sort: 'heading',
            isDescending: false,
        })
    }

    const onFilterSubmit = (data, { setSubmitting }) => {
        setSubmitting(true)
        onFormSubmit(data.heading)
        setSubmitting(false)
    }

    return (
        <Formik
            validateOnChange={true}
            initialValues={initialValues}
            onReset={onFilterSubmit}
            onSubmit={onFilterSubmit}>
            {({ isSubmitting }) => (
                <Form noValidate autoComplete='off'>
                    <JumboCardQuick noWrapper sx={{ display: display, borderRadius: 0 }}>
                        <Div
                            className='grid-filter-parent'
                            style={{ display: 'flex', margin: '0% 1.5% 1.5% 1.5%', flexWrap: 'wrap' }}>
                            <Div className='report-filter-checkbox'>
                                <Div sx={{ mr: 3, mt: 1.5 }}>
                                    <Div>
                                        <Typography>Heading</Typography>
                                    </Div>
                                    <Div sx={{ mt: 0.5 }}>
                                        <JumboAppTextField style={{ width: 220 }} size='small' name='heading' />
                                    </Div>
                                </Div>
                                <Div sx={{ mr: 3, mt: 3.5 }}>
                                    <Div sx={{ mt: 0.5 }}>
                                        <FormGroup>
                                            <FormControlLabel
                                                control={<Checkbox />}
                                                type='checkbox'
                                                checked={includeDeletedRecords}
                                                onChange={(e) =>
                                                    setincludeDeletedRecordsSelection(!includeDeletedRecords)
                                                }
                                                label='Show All'
                                            />
                                        </FormGroup>
                                    </Div>
                                </Div>
                            </Div>
                            <Div className='grid-filter-Button' sx={{ mt: sm ? 3 : 4.5 }}>
                                <Stack direction={'row'} spacing={1}>
                                    <LoadingButton
                                        size={'small'}
                                        type='submit'
                                        onClick={() => filterIconColor(true)}
                                        variant={'contained'}
                                        loading={isSubmitting || mutation.isLoading}>
                                        <SearchIcon sx={{ fontSize: 18 }} /> Search
                                    </LoadingButton>
                                    <LoadingButton
                                        size={'small'}
                                        type={'reset'}
                                        onClick={() => setincludeDeletedRecordsSelection(false)}
                                        variant={'contained'}>
                                        <AutorenewRoundedIcon sx={{ fontSize: 18 }} /> Clear
                                    </LoadingButton>
                                </Stack>
                            </Div>
                        </Div>
                    </JumboCardQuick>
                </Form>
            )}
        </Formik>
    )
}

export default NotifyGridFilter
